module.exports = __webpack_public_path__ + "static/arnospillaert-5a310b0032ef9aac27bff55a5a68c676.jpg";